import { Action, createAction, handleActions } from "redux-actions";
import { calculateDate } from "~libs/dateCalculator";
import { FiltroValue, TakeValue } from "../../types";

/**
 * El estado inicial nombra los campos `fechaVencimiento*`, pero las acciones que
 * los escribirían (`SELECT_FECHA_DESDE_FILTRO_POLIZAS_MULTI` y
 * `SELECT_FECHA_HASTA_FILTRO_POLIZAS_MULTI`) no tienen handler acá, y el
 * container lee otros nombres (`fechaVigencia*`): el filtro de fecha nunca se
 * aplica. Queda como estaba antes de la migración.
 */
interface FiltrosPolizasMultiramaState {
  take: TakeValue;
  page: number;
  searchCriteria: string;
  fechaVencimientoDesde: Date;
  fechaVencimientoHasta: Date;
  rama: FiltroValue;
  compania: FiltroValue;
  estado: FiltroValue;
}

const setInitialStateFiltroMultirama = createAction(
  "SET_POLIZAS_FILTROS_INITIAL_STATE_POLIZAS_MULTI"
);

const setPage = createAction(
  "SET_LISTADO_POLIZAS_PAGE_POLIZAS_MULTI",
  (page: number) => ({
    page,
  })
);

const setTake = createAction(
  "SET_LISTADO_POLIZAS_ROWS_PER_PAGE_POLIZAS_MULTI",
  (take: TakeValue) => ({
    take,
  })
);

const selectFechaVigenciaDesde = createAction(
  "SELECT_FECHA_DESDE_FILTRO_POLIZAS_MULTI",
  (fechaDesde: Date | string) => ({ fechaDesde })
);

const selectFechaVigenciaHasta = createAction(
  "SELECT_FECHA_HASTA_FILTRO_POLIZAS_MULTI",
  (fechaHasta: Date | string) => ({ fechaHasta })
);

const selectSearchCriteria = createAction(
  "SELECT_SEARCH_CRITERIA_POLIZAS_MULTI",
  (searchCriteria: string) => ({
    searchCriteria,
  })
);

const selectRama = createAction(
  "SELECT_RAMA_POLIZAS_MULTI",
  (rama: FiltroValue) => ({
    rama,
  })
);

const selectCompania = createAction(
  "SELECT_NEGOCIO_POLIZAS_MULTI",
  (compania: FiltroValue) => ({
    compania,
  })
);

const selectEstado = createAction(
  "SELECT_ESTADO_POLIZAS_MULTI",
  (estado: FiltroValue) => ({
    estado,
  })
);

const clearData = createAction("CLEAR_DATA_FILTRO_POLIZAS_MULTI");

const listadoPolizasMultiramaFiltroInitialState: FiltrosPolizasMultiramaState =
  {
    take: 10,
    page: 0,
    searchCriteria: "",
    fechaVencimientoDesde: calculateDate(new Date(), -30),
    fechaVencimientoHasta: new Date(),
    rama: "",
    compania: "",
    estado: "",
  };

const listadoPolizaMultiramaFiltroReducer = handleActions<
  FiltrosPolizasMultiramaState,
  any
>(
  {
    [setInitialStateFiltroMultirama.toString()]:
      (): FiltrosPolizasMultiramaState => {
        return {
          ...listadoPolizasMultiramaFiltroInitialState,
        };
      },
    [setPage.toString()]: (
      state: FiltrosPolizasMultiramaState,
      action: Action<{ page: number }>
    ): FiltrosPolizasMultiramaState => {
      return {
        ...state,
        page: action.payload.page,
      };
    },
    [setTake.toString()]: (
      state: FiltrosPolizasMultiramaState,
      action: Action<{ take: TakeValue }>
    ): FiltrosPolizasMultiramaState => {
      return {
        ...state,
        take: action.payload.take,
      };
    },
    [selectSearchCriteria.toString()]: (
      state: FiltrosPolizasMultiramaState,
      action: Action<{ searchCriteria: string }>
    ): FiltrosPolizasMultiramaState => {
      return {
        ...state,
        searchCriteria: action.payload.searchCriteria,
      };
    },
    [selectCompania.toString()]: (
      state: FiltrosPolizasMultiramaState,
      action: Action<{ compania: FiltroValue }>
    ): FiltrosPolizasMultiramaState => {
      return {
        ...state,
        compania: action.payload.compania,
      };
    },
    [selectRama.toString()]: (
      state: FiltrosPolizasMultiramaState,
      action: Action<{ rama: FiltroValue }>
    ): FiltrosPolizasMultiramaState => {
      return {
        ...state,
        rama: action.payload.rama,
      };
    },
    [selectEstado.toString()]: (
      state: FiltrosPolizasMultiramaState,
      action: Action<{ estado: FiltroValue }>
    ): FiltrosPolizasMultiramaState => {
      return {
        ...state,
        estado: action.payload.estado,
      };
    },
    [clearData.toString()]: (): FiltrosPolizasMultiramaState => {
      return {
        ...listadoPolizasMultiramaFiltroInitialState,
      };
    },
  },
  listadoPolizasMultiramaFiltroInitialState
);

export { listadoPolizaMultiramaFiltroReducer };
export {
  setTake,
  setPage,
  selectSearchCriteria,
  selectFechaVigenciaHasta,
  selectFechaVigenciaDesde,
  setInitialStateFiltroMultirama,
  selectRama,
  selectCompania,
  selectEstado,
  clearData,
};
